import { render } from "./ApiDocsTestDialog.vue?vue&type=template&id=467fa5b6&scoped=true"
import script from "./ApiDocsTestDialog.vue?vue&type=script&lang=js"
export * from "./ApiDocsTestDialog.vue?vue&type=script&lang=js"

import "./ApiDocsTestDialog.vue?vue&type=style&index=0&id=467fa5b6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-467fa5b6"]])

export default __exports__